import axiosClient from 'utils/axiosClient';
import api from 'api';

const getEbooksReports = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.EBOOK_REPORTS, {params: data});
	return response.data;
};
const getIssuancesReport = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.ISSUANCES_REPORTS, {params: data});
	return response.data;
};
const getUnreturnedReports = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.UNRETURNED_REPORTS, {params: data});
	return response.data;
};
const getUnreturnedReportsPerStudent = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.UNRETURNED_REPORTS_PER_STUDENT, {
		params: data
	});
	return response.data;
};
const getUnreturnedReportsPerUser = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.UNRETURNED_REPORTS_PER_USER, {
		params: data
	});
	return response.data;
};
const getRoomsReports = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.ROOMS_REPORTS, {params: data});
	return response.data;
};

const getIssuancesPerStudent = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.ISSUANCE_PER_STUDENT, {params: data});
	return response.data;
};
const getEbooksPerStudent = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.EBOOK_PER_STUDENT, {params: data});
	return response.data;
};

const getIssuancesPerUser = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.ISSUANCE_PER_USER, {params: data});
	return response.data;
};
const getEbooksPerUser = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.EBOOK_PER_USER, {params: data});
	return response.data;
};
const getPrintingReports = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.PRINTING_REPORTS, {params: data});
	return response.data;
};
const getPackageBooksReport = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY_REPORTS.PACKAGE_BOOKS_REPORTS, {params: data});
	return response.data;
};

const service = {
	getEbooksReports,
	getIssuancesReport,
	getUnreturnedReports,
	getUnreturnedReportsPerStudent,
	getRoomsReports,
	getPrintingReports,
	getIssuancesPerStudent,
	getEbooksPerStudent,
	getIssuancesPerUser,
	getEbooksPerUser,
	getUnreturnedReportsPerUser,
	getPackageBooksReport
};

export default service;
